/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Nosubscriptionstitle2Inputs */

const id_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Ada Langganan Ditemukan`)
};

const ms_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada Langganan Ditemui`)
};

const da_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen Abonnementer Fundet`)
};

const de_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Abonnements gefunden`)
};

const en_us2_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Subscriptions Found`)
};

const es_es2_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron suscripciones`)
};

const es_mx2_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron suscripciones`)
};

const fil_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang Nakitang Subscription`)
};

const fr_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun abonnement trouvé`)
};

const it_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna sottoscrizione trovata`)
};

const hu_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs feliratkozás`)
};

const nl_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen abonnementen gevonden`)
};

const no_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen abonnementer funnet`)
};

const pl_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono subskrypcji`)
};

const pt_br2_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma assinatura encontrada`)
};

const pt_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma subscrição encontrada`)
};

const ro_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit abonamente`)
};

const fi_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tilauksia`)
};

const sv_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga prenumerationer hittades`)
};

const vi_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy đăng ký`)
};

const tr_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Bulunamadı`)
};

const cs_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné odběry`)
};

const bg_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени абонаменти`)
};

const ru_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписки не найдены`)
};

const uk_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписок не знайдено`)
};

const ar_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على اشتراكات`)
};

const hi_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई सब्सक्रिप्शन नहीं मिला`)
};

const th_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบการสมัครรับ`)
};

const ja_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションが見つかりません`)
};

const zh_cn2_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到订阅`)
};

const zh_hant1_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到訂閱`)
};

const ko_notifications_nosubscriptionstitle2 = /** @type {(inputs: Notifications_Nosubscriptionstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No Subscriptions Found" |
*
* @param {Notifications_Nosubscriptionstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_nosubscriptionstitle2 = /** @type {((inputs?: Notifications_Nosubscriptionstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Nosubscriptionstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_nosubscriptionstitle2(inputs)
	if (locale === "ms") return ms_notifications_nosubscriptionstitle2(inputs)
	if (locale === "da") return da_notifications_nosubscriptionstitle2(inputs)
	if (locale === "de") return de_notifications_nosubscriptionstitle2(inputs)
	if (locale === "en-US") return en_us2_notifications_nosubscriptionstitle2(inputs)
	if (locale === "es-ES") return es_es2_notifications_nosubscriptionstitle2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_nosubscriptionstitle2(inputs)
	if (locale === "fil") return fil_notifications_nosubscriptionstitle2(inputs)
	if (locale === "fr") return fr_notifications_nosubscriptionstitle2(inputs)
	if (locale === "it") return it_notifications_nosubscriptionstitle2(inputs)
	if (locale === "hu") return hu_notifications_nosubscriptionstitle2(inputs)
	if (locale === "nl") return nl_notifications_nosubscriptionstitle2(inputs)
	if (locale === "no") return no_notifications_nosubscriptionstitle2(inputs)
	if (locale === "pl") return pl_notifications_nosubscriptionstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_nosubscriptionstitle2(inputs)
	if (locale === "pt") return pt_notifications_nosubscriptionstitle2(inputs)
	if (locale === "ro") return ro_notifications_nosubscriptionstitle2(inputs)
	if (locale === "fi") return fi_notifications_nosubscriptionstitle2(inputs)
	if (locale === "sv") return sv_notifications_nosubscriptionstitle2(inputs)
	if (locale === "vi") return vi_notifications_nosubscriptionstitle2(inputs)
	if (locale === "tr") return tr_notifications_nosubscriptionstitle2(inputs)
	if (locale === "cs") return cs_notifications_nosubscriptionstitle2(inputs)
	if (locale === "bg") return bg_notifications_nosubscriptionstitle2(inputs)
	if (locale === "ru") return ru_notifications_nosubscriptionstitle2(inputs)
	if (locale === "uk") return uk_notifications_nosubscriptionstitle2(inputs)
	if (locale === "ar") return ar_notifications_nosubscriptionstitle2(inputs)
	if (locale === "hi") return hi_notifications_nosubscriptionstitle2(inputs)
	if (locale === "th") return th_notifications_nosubscriptionstitle2(inputs)
	if (locale === "ja") return ja_notifications_nosubscriptionstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_nosubscriptionstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_nosubscriptionstitle2(inputs)
	return ko_notifications_nosubscriptionstitle2(inputs)
});
export { notifications_nosubscriptionstitle2 as "notifications.noSubscriptionsTitle" }